import { ALGOS_E } from "@constants/Algos";
import {
  ActionAddMinerProfile,
  ActionDeleteMinerProfile,
  ActionEditMinerProfile,
  ActionMinerProfileBase,
  ActionMinerProfiles,
  ActionSetMinerProfiles,
} from "./actionTypes";
import { IMinerProfileBase } from "@services/minerProfiles";

export interface IMinerProfile extends IMinerProfileBase {}

interface IState {
  profiles: IMinerProfile[];
  total: number;
}

const initialState = {
  profiles: [] as IMinerProfile[],
  total: 0,
};

const reducer = (
  state = initialState,
  action: ActionMinerProfileBase
): IState => {
  switch (action.type) {
    case ActionMinerProfiles.SET_PROFILES:
      const { profiles, Total } = (action as ActionSetMinerProfiles).payload;
      return {
        ...state,
        profiles,
        total: Total,
      };
    case ActionMinerProfiles.DELETE_PROFILE:
      const id = (action as ActionDeleteMinerProfile).payload;
      return {
        ...state,
        profiles: state.profiles.filter((p) => p.id !== id),
      };
    case ActionMinerProfiles.EDIT_PROFILES: {
      const profile = (action as ActionEditMinerProfile).payload;
      const index = state.profiles.findIndex((p) => p.id === profile.id);
      if (index < 0) return state;

      return {
        ...state,
        profiles: [
          ...state.profiles.slice(0, index),
          profile,
          ...state.profiles.slice(index + 1),
        ],
      };
    }
    case ActionMinerProfiles.ADD_PROFILE: {
      const profile = (action as ActionAddMinerProfile).payload;
      return {
        ...state,
        profiles: [...state.profiles, profile],
      };
    }
    default:
      return state;
  }
};

export default reducer;
